(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gga-community-voices"] && !Shopify.designMode) return;
  try {
    
(function() {
  const autoSelector = '[data-ggv-inline] [data-ggv-load]';
  document.addEventListener('play', function(event) {
    if (!event.target.matches('.ggv-native-video')) return;
    document.querySelectorAll('.ggv-native-video').forEach(function(video) { if (video !== event.target) video.pause(); });
  }, true);
  document.addEventListener('toggle', function(event) {
    const details = event.target;
    if (!details.matches('.ggv-more') || details.open) return;
    details.querySelectorAll('.ggv-native-video').forEach(function(video) { video.pause(); });
  }, true);
  document.addEventListener('shopify:block:select', function(event) {
    const details = event.target.closest('.ggv-more');
    if (details) details.open = true;
  });
  if (!document.querySelector('[data-ggv-load]')) return;
  let privacyReady = false;
  const allowed = function() {
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    return privacyReady && privacy && privacy.marketingAllowed() && privacy.analyticsProcessingAllowed() && privacy.saleOfDataAllowed();
  };
  const loadPlayer = async function(button, automatic) {
    const card = button.closest('[data-ggv-post]');
    if (!card || card.dataset.ggvLoaded || button.disabled) return;
    if (automatic && !allowed()) return;
    let post;
    try { post = new URL(card.dataset.ggvPost); } catch (error) { return; }
    const isInstagram = ['www.instagram.com', 'instagram.com'].includes(post.hostname) && /^\/(p|reel)\/[A-Za-z0-9_-]+\/?$/.test(post.pathname);
    const isFacebook = ['www.facebook.com', 'facebook.com'].includes(post.hostname) && /^\/reel\/\d+\/?$/.test(post.pathname);
    if (post.protocol !== 'https:' || (!isInstagram && !isFacebook)) return;
    const mount = card.querySelector('.ggv-embed-mount');
    const status = card.querySelector('[data-ggv-status]');
    const preview = card.querySelector('.ggv-media');
    button.disabled = true;
    status.hidden = false;
    status.textContent = button.dataset.loading;
    if (isFacebook) {
      const frame = document.createElement('iframe');
      const playerUrl = new URL('https://www.facebook.com/plugins/video.php');
      playerUrl.searchParams.set('href', post.origin + post.pathname);
      playerUrl.searchParams.set('show_text', 'false');
      playerUrl.searchParams.set('width', '500');
      playerUrl.searchParams.set('height', '891');
      playerUrl.searchParams.set('autoplay', 'false');
      frame.src = playerUrl.href;
      frame.className = 'ggv-facebook-player';
      frame.title = button.getAttribute('aria-label');
      frame.allow = 'encrypted-media; picture-in-picture; fullscreen';
      frame.allowFullscreen = true;
      frame.addEventListener('load', function() {
        if (!frame.isConnected) return;
        status.hidden = true;
      }, {once: true});
      frame.addEventListener('error', function() {
        mount.replaceChildren();
        preview.hidden = false;
        button.disabled = false;
        delete card.dataset.ggvLoaded;
        status.hidden = false;
        status.textContent = button.dataset.fallback;
      }, {once: true});
      mount.replaceChildren(frame);
      preview.hidden = true;
      card.dataset.ggvLoaded = automatic ? 'auto' : 'manual';
      return;
    }
    const quote = document.createElement('blockquote');
    quote.className = 'instagram-media';
    quote.dataset.instgrmPermalink = post.origin + post.pathname;
    quote.dataset.instgrmVersion = '14';
    const link = document.createElement('a');
    link.href = post.origin + post.pathname;
    link.textContent = button.dataset.fallback;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    quote.appendChild(link);
    mount.replaceChildren(quote);
    const labelPlayer = function() {
      const frame = mount.querySelector('iframe');
      if (!frame || frame.getBoundingClientRect().height < 180) return false;
      frame.title = button.getAttribute('aria-label') || 'Instagram performance';
      preview.hidden = true;
      status.hidden = true;
      card.dataset.ggvLoaded = automatic ? 'auto' : 'manual';
      return true;
    };
    const observer = new MutationObserver(function() {
      if (labelPlayer()) observer.disconnect();
    });
    observer.observe(mount, {childList: true, subtree: true, attributes: true, attributeFilter: ['height', 'style']});
    try {
      if (!window.instgrm) {
        if (!window.ggaInstagramLoad) window.ggaInstagramLoad = new Promise(function(resolve, reject) {
          const script = document.createElement('script');
          script.src = 'https://www.instagram.com/embed.js';
          script.async = true;
          script.onload = resolve;
          script.onerror = reject;
          document.head.appendChild(script);
        });
        await window.ggaInstagramLoad;
      }
      if (automatic && !allowed()) {
        observer.disconnect();
        mount.replaceChildren();
        button.disabled = false;
        status.hidden = true;
        return;
      }
      window.instgrm.Embeds.process();
      if (labelPlayer()) observer.disconnect();
      setTimeout(function() {
        if (card.dataset.ggvLoaded) return;
        observer.disconnect();
        mount.replaceChildren();
        button.disabled = false;
        status.textContent = button.dataset.fallback;
      }, 15000);
    } catch (error) {
      observer.disconnect();
      mount.replaceChildren();
      button.disabled = false;
      status.textContent = button.dataset.fallback;
    }
  };
  const viewport = 'IntersectionObserver' in window ? new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting && allowed()) loadPlayer(entry.target, true);
    });
  }, {rootMargin: '200px 0px'}) : null;
  const updateInline = function() {
    document.querySelectorAll(autoSelector).forEach(function(button) {
      const card = button.closest('[data-ggv-post]');
      if (!allowed()) {
        if (viewport) viewport.unobserve(button);
        if (card.dataset.ggvLoaded === 'auto') {
          card.querySelector('.ggv-embed-mount').replaceChildren();
          card.querySelector('.ggv-media').hidden = false;
          button.disabled = false;
          delete card.dataset.ggvLoaded;
        }
        return;
      }
      if (viewport) { viewport.unobserve(button); viewport.observe(button); }
      else loadPlayer(button, true);
    });
  };
  const initialize = function() {
    if (!document.querySelector(autoSelector)) return;
    if (window.Shopify && window.Shopify.customerPrivacy) {
      privacyReady = true;
      updateInline();
    } else if (window.Shopify && window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], function(error) {
        privacyReady = !error;
        updateInline();
      });
    }
  };
  document.addEventListener('click', function(event) {
    const button = event.target.closest('[data-ggv-load]');
    if (button) loadPlayer(button, false);
  });
  document.addEventListener('visitorConsentCollected', updateInline);
  document.addEventListener('shopify:section:load', initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gga-curriculum-licensing"] && !Shopify.designMode) return;
  try {
    
function initGcl(root){if(root.dataset.ready)return;root.dataset.ready='true';const interest=root.querySelector('#gcl-interest');root.querySelectorAll('[data-gcl-interest="pilot"]').forEach(link=>link.addEventListener('click',()=>{interest.value='Teacher pilot interest';const details=root.querySelector('#gcl-details');if(!details.value.trim())details.value='I’m interested in the teacher pilot. ';}));root.querySelectorAll('.gcl-hero a:not([data-gcl-interest])').forEach(link=>link.addEventListener('click',()=>{interest.value='Curriculum Licensing';}));const feedback=root.querySelector('[data-gcl-feedback]');if(feedback)feedback.focus();}
document.querySelectorAll('[data-gcl]').forEach(initGcl);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-gcl]').forEach(initGcl));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gga-curriculum-main"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('change',function(event){if(event.target.matches('[data-ggc-audience]')){const form=event.target.closest('form');const tags=form.querySelector('[data-ggc-tags]');tags.value='newsletter,curriculum-waitlist'+(event.target.value?','+event.target.value:'');}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gga-listen-page"]) return;
  try {
    
function initGgaLibrary(root) {
  if (root.dataset.ready) return;
  root.dataset.ready = 'true';
  const controller = new AbortController();
  const on = (el, event, handler) => el.addEventListener(event, handler, { signal: controller.signal });
  const cards = [...root.querySelectorAll('[data-gml-card]')];
  const search = root.querySelector('[data-gml-search]');
  const categoryButtons = [...root.querySelectorAll('[data-gml-theme]')];
  const status = root.querySelector('[data-gml-status]');
  const clear = root.querySelector('[data-gml-clear]');
  const more = root.querySelector('[data-gml-more]');
  const empty = root.querySelector('.gml-empty');
  let dialog, audio;
  function preparePlayer() {
    if (dialog) return;
    root.append(root.querySelector('[data-gml-player-template]').content.cloneNode(true));
    dialog = root.querySelector('.gml-dialog');
    audio = root.querySelector('[data-gml-audio]');
    on(root.querySelector('[data-gml-close]'), 'click', closePlayer);
    on(dialog, 'cancel', event => { event.preventDefault(); closePlayer(); });
    on(dialog, 'click', event => {
      if (event.target !== dialog) return;
      const box = dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) closePlayer();
    });
    on(audio, 'error', () => { if (audio.hasAttribute('src')) root.querySelector('.gml-player-error').hidden = false; });
  }
  const recordings = JSON.parse(root.querySelector('[data-gml-recordings]').textContent);
  const approvedPreviews = JSON.parse(root.closest('.shopify-section').querySelector('[data-gga-approved-previews]').textContent);
  Object.entries(approvedPreviews).forEach(([id, url]) => { if (recordings[id]) recordings[id].audio = url; });
  let category = '', limit = 12, lastFocus = null;
  const normalize = value => value.toLocaleLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[’‘]/g, "'");
  function update() {
    const words = normalize(search.value.trim()).split(/\s+/).filter(Boolean);
    const matches = cards.filter(card => (!category || card.dataset.themes.split('|').includes(category)) && words.every(word => normalize(card.dataset.search).includes(word)));
    const shown = new Set(matches.slice(0, limit));
    cards.forEach(card => { card.hidden = !shown.has(card); });
    categoryButtons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.gmlTheme === category)));
    status.textContent = `${status.dataset.showing} ${shown.size} ${status.dataset.of} ${matches.length} ${status.dataset.songs}`;
    clear.hidden = !category && !search.value;
    more.hidden = matches.length <= limit;
    empty.hidden = matches.length > 0;
    return matches;
  }
  function goToResults(matches) {
    const destination = matches[0] || empty;
    if (destination === empty) destination.tabIndex = -1;
    destination.focus({ preventScroll: true });
    destination.scrollIntoView({ behavior: 'auto', block: 'start' });
  }
  function closePlayer() {
    audio.pause();
    audio.removeAttribute('src');
    audio.load();
    if (dialog.open) dialog.close();
    if (lastFocus?.isConnected) lastFocus.focus({ preventScroll: true });
  }
  function openPlayer(id, trigger) {
    const track = recordings[id];
    if (!track || !track.audio) return;
    preparePlayer();
    lastFocus = trigger;
    audio.pause();
    root.querySelector('[data-gml-player-title]').textContent = track.title;
    const views = root.querySelector('[data-gml-player-views]');
    views.hidden = !track.views;
    views.textContent = track.views || '';

    const art = root.querySelector('[data-gml-player-art]');
    art.hidden = !track.art;
    if (track.art) art.src = track.art;
    for (const type of ['spotify', 'apple', 'release']) {
      const link = root.querySelector(`[data-gml-${type}]`);
      link.hidden = !track[type];
      if (track[type]) link.href = track[type];
      else link.removeAttribute('href');
    }
    root.querySelector('.gml-player-error').hidden = true;
    audio.src = track.audio;
    dialog.showModal();
    audio.play().catch(() => {});
  }
  on(search, 'input', () => { limit = 12; update(); });
  on(clear, 'click', () => { category = ''; search.value = ''; limit = 12; goToResults(update()); });
  on(more, 'click', () => {
    const oldLimit = limit;
    limit += 12;
    const matches = update();
    if (matches[oldLimit]) {
      matches[oldLimit].focus({ preventScroll: true });
      matches[oldLimit].scrollIntoView({ behavior: 'auto', block: 'start' });
    }
  });
  on(root, 'click', event => {
    const themeButton = event.target.closest('[data-gml-theme]');
    if (themeButton) {
      category = themeButton.dataset.gmlTheme;
      search.value = '';
      limit = 12;
      goToResults(update());
      return;
    }
    const trigger = event.target.closest('[data-gml-play]');
    if (trigger) openPlayer(trigger.dataset.gmlPlay, trigger);
  });
  root.querySelector('.gml-tools').hidden = false;
  root.querySelectorAll('[data-gml-play]').forEach(button => { button.hidden = !recordings[button.dataset.gmlPlay]?.audio; });
  update();
  root.ggaLibraryCleanup = () => { audio?.pause(); if (dialog?.open) dialog.close(); dialog?.remove(); controller.abort(); delete root.dataset.ready; };
}
document.querySelectorAll('[data-gga-library]').forEach(initGgaLibrary);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-gga-library]').forEach(initGgaLibrary));
document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-gga-library]').forEach(root => root.ggaLibraryCleanup?.()));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gga-music-licensing"] && !Shopify.designMode) return;
  try {
    
function initGgaMusic(root){
 if(root.dataset.ready)return;root.dataset.ready='true';
 const cards=[...root.querySelectorAll('.gga-catalog-grid .gga-track')],recordings=[...root.querySelectorAll('.gga-recordings [data-track]')],search=root.querySelector('#gga-song-search'),theme=root.querySelector('#gga-theme-filter'),style=root.querySelector('#gga-style-filter'),type=root.querySelector('#gga-version-filter'),status=root.querySelector('.gga-results'),more=root.querySelector('.gga-load-more'),reset=root.querySelector('.gga-reset'),empty=root.querySelector('.gga-empty'),song=root.querySelector('#gga-requested-song'),dialog=root.querySelector('.gga-player-dialog'),mount=root.querySelector('.gga-player-mount'),titles=root.querySelector('#gga-song-titles');
 const approvedPreviews=JSON.parse(root.closest('.shopify-section').querySelector('[data-gga-approved-previews]').textContent);
 let limit=12,lastFocus=null;
 const normalize=s=>s.toLocaleLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/[’‘]/g,"'");
 const addOptions=(el,values)=>values.forEach(value=>{const o=document.createElement('option');o.value=value;o.textContent=value;el.append(o)});
 const rec=id=>recordings.find(c=>c.dataset.track===id);
 const versions=c=>c.dataset.versionIds.split('|').map(rec);
 addOptions(theme,[...root.querySelectorAll('[data-theme-jump]')].map(c=>c.dataset.themeJump));addOptions(style,[...new Set(recordings.flatMap(c=>c.dataset.moods.split('|').filter(Boolean)))].sort());addOptions(type,[...new Set(recordings.map(c=>c.dataset.type))].sort());
 recordings.forEach(c=>{const o=document.createElement('option');o.value=c.dataset.title+' ('+c.dataset.version+')';titles.append(o)});
 const versionMatches=r=>(!type.value||r.dataset.type===type.value)&&(!style.value||r.dataset.moods.split('|').includes(style.value));
 function update(){const words=normalize(search.value.trim()).split(/\s+/).filter(Boolean);const matches=cards.filter(c=>words.every(w=>normalize(c.dataset.search).includes(w))&&(!theme.value||c.dataset.themes.split('|').includes(theme.value))&&versions(c).some(versionMatches));const visible=new Set(matches.slice(0,limit));cards.forEach(c=>{c.hidden=!visible.has(c);const details=c.querySelector('.gga-versions');if(details){details.open=false;c.querySelectorAll('[data-version-row]').forEach(row=>row.classList.toggle('is-match',Boolean(type.value||style.value)&&versionMatches(rec(row.dataset.versionRow))))}});status.textContent=`${status.dataset.showingLabel} ${Math.min(limit,matches.length)} ${status.dataset.ofLabel} ${matches.length} ${status.dataset.totalLabel}`;more.hidden=matches.length<=limit;reset.hidden=!(search.value||theme.value||style.value||type.value);empty.hidden=matches.length!==0;}
 [search,theme,style,type].forEach(el=>el.addEventListener(el===search?'input':'change',()=>{limit=12;update()}));reset.addEventListener('click',()=>{search.value='';theme.value='';style.value='';type.value='';limit=12;update();search.focus()});more.addEventListener('click',()=>{const previous=cards.filter(c=>!c.hidden).length;limit+=12;update();const next=cards.filter(c=>!c.hidden)[previous];if(next){next.tabIndex=-1;next.focus({preventScroll:true})}});
 function close(){mount.replaceChildren();if(dialog.open)dialog.close();if(lastFocus)lastFocus.focus({preventScroll:true})}
 function license(id){const c=rec(id);if(!c)return;song.value=c.dataset.title+' ('+c.dataset.version+')';song.classList.add('gga-selected');window.setTimeout(()=>song.classList.remove('gga-selected'),2000);song.focus({preventScroll:true});song.scrollIntoView({behavior:'auto',block:'center'});}
 root.addEventListener('click',e=>{const jump=e.target.closest('[data-theme-jump]');if(jump){e.preventDefault();search.value='';theme.value=jump.dataset.themeJump;style.value='';type.value='';limit=12;update();const firstMatch=cards.find(card=>!card.hidden);const destination=firstMatch||root.querySelector('.gga-results');destination.tabIndex=-1;destination.focus({preventScroll:true});destination.scrollIntoView({behavior:'auto',block:'start'});return}const licensing=e.target.closest('[data-license]');if(licensing){e.preventDefault();license(licensing.dataset.license);return}const play=e.target.closest('[data-preview]');if(!play)return;const c=rec(play.dataset.preview);if(!c)return;lastFocus=play;root.querySelector('#gga-player-title').textContent=c.dataset.title;const views=root.querySelector('[data-gga-player-views]');views.hidden=!c.dataset.views;views.textContent=c.dataset.views||'';mount.replaceChildren();if(c.dataset.apple&&!approvedPreviews[c.dataset.track]){const u=new URL(c.dataset.apple);u.hostname='embed.music.apple.com';u.searchParams.delete('uo');const iframe=document.createElement('iframe');iframe.src=u.href;iframe.title=c.dataset.title+': Apple Music preview';iframe.allow='autoplay *; encrypted-media *; fullscreen *';iframe.referrerPolicy='strict-origin-when-cross-origin';mount.append(iframe)}else if(approvedPreviews[c.dataset.track]||c.dataset.audio){const audio=document.createElement('audio');audio.controls=true;audio.preload='none';audio.src=approvedPreviews[c.dataset.track]||c.dataset.audio;audio.setAttribute('aria-label',c.dataset.title+' preview');mount.append(audio)}const official=root.querySelector('.gga-listen-link');official.hidden=!c.dataset.listen;if(c.dataset.listen){official.href=c.dataset.listen}else{official.removeAttribute('href')};const spotify=root.querySelector('.gga-spotify-link');spotify.hidden=!c.dataset.spotify;spotify.href=c.dataset.spotify;root.querySelector('.gga-player-license').dataset.licenseId=c.dataset.track;dialog.showModal();});
 root.querySelector('.gga-dialog-close').addEventListener('click',close);dialog.addEventListener('cancel',e=>{e.preventDefault();close()});dialog.addEventListener('click',e=>{if(e.target===dialog){const b=dialog.getBoundingClientRect();if(e.clientX<b.left||e.clientX>b.right||e.clientY<b.top||e.clientY>b.bottom)close()}});root.querySelector('.gga-player-license').addEventListener('click',e=>{e.preventDefault();const id=e.currentTarget.dataset.licenseId;close();license(id)});
 root.querySelector('.gga-filters').hidden=false;update();
 const requested=new URLSearchParams(location.search).get('track');if(requested){const c=recordings.find(c=>c.dataset.track===requested||c.dataset.title===requested);if(c)song.value=c.dataset.title+' ('+c.dataset.version+')'}
 const success=root.querySelector('.gga-form-success');if(success){success.focus();success.scrollIntoView({block:'center'})}
}
document.querySelectorAll('[data-gga-music]').forEach(initGgaMusic);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-gga-music]').forEach(initGgaMusic));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gga-song-page"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('play',function(event){if(event.target.matches('.gga-song audio')){document.querySelectorAll('.gga-song audio').forEach(function(player){if(player!==event.target)player.pause();});}},true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
